import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../../lib/supabase/AuthContext';

const ProtectedRoute: React.FC = () => {
  const { session, loading } = useAuth();

  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Rediriger vers la page de connexion si l'utilisateur n'est pas authentifié
  if (!session) {
    return <Navigate to="/auth" replace />;
  }

  // Si l'utilisateur est authentifié, afficher le contenu protégé
  return <Outlet />;
};

export default ProtectedRoute; 